// @flow
import React, { Component, Fragment } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import BannerComments from 'components/banner/BannerComments/BannerComments';
import BannerCommentInput from 'components/banner/BannerCommentInput/BannerCommentInput';
import { BannersActions } from 'store/actionCreators';
import type { Comment, RemoveComment, SubCommentsMap } from 'store/modules/banners';
import QuestionModal from 'components/common/QuestionModal';
import { type ContextRouter, withRouter } from 'react-router-dom';

type Props = {
  bannerId: ?string,
  comments: ?(Comment[]),
  subCommentsMap: SubCommentsMap,
  shouldCancel: boolean,
  logged: boolean,
  loading: boolean,
  username: ?string,
  removeComment: RemoveComment,
  commentsCount: ?number,
} & ContextRouter;

class BannerCommentsContainer extends Component<Props> {
  onOpenRemove = (payload: { commentId: string, parentId: ?string }) => {
    BannersActions.openCommentRemove(payload);
  };

  onCancelRemove = () => {
    BannersActions.cancelCommentRemove();
  };

  onConfirmRemove = () => {
    const { bannerId, removeComment } = this.props;
    if (!bannerId || !removeComment.commentId) return;
    BannersActions.removeComment({
      bannerId,
      commentId: removeComment.commentId,
    });
  };

  onEditComment = ({
    commentId,
    parentId,
    text,
  }: {
    commentId: string,
    parentId: ?string,
    text: string,
  }) => {
    const { bannerId } = this.props;
    if (!bannerId) return Promise.resolve();
    return BannersActions.editComment({
      bannerId,
      commentId,
      text,
      parentId,
    });
  };

  onWriteComment = async (text: string, replyTo: ?string, parentId?: ?string) => {
    const { bannerId } = this.props;
    if (!bannerId) return Promise.resolve();
    let comment = null;
    try {
      comment = await BannersActions.writeComment({
        bannerId,
        text,
        replyTo,
      });
      if (replyTo) {
        await this.onReadReplies(replyTo, parentId);
      } else {
        await BannersActions.readComments({ bannerId });
      }
    } catch (e) {
      console.log(e);
    }
    return comment;
  };

  initialize = async () => {
    const { bannerId, shouldCancel } = this.props;
    if (!bannerId) return;
    try {
      if (shouldCancel) return;
      await BannersActions.readComments({ bannerId });
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.bannerId !== this.props.bannerId) {
      this.initialize();
    }
  }

  onReadReplies = (commentId: string, parentId?: ?string) => {
    const { bannerId } = this.props;
    if (!bannerId) return Promise.resolve(null);
    return BannersActions.readSubComments({
      bannerId,
      commentId,
      parentId,
    });
  };

  render() {
    const {
      comments,
      subCommentsMap,
      logged,
      loading,
      username,
      removeComment,
      commentsCount,
    } = this.props;

    if (loading) return null;

    return (
      <Fragment>
        <BannerComments
          logged={logged}
          commentInput={logged && <BannerCommentInput onWriteComment={this.onWriteComment} />}
          comments={comments}
          subCommentsMap={subCommentsMap}
          onReply={this.onWriteComment}
          onReadReplies={this.onReadReplies}
          username={username}
          onOpenRemove={this.onOpenRemove}
          onEditComment={this.onEditComment}
          commentsCount={commentsCount || 0}
          currentPath={this.props.location.pathname}
        />
        <QuestionModal
          title="배너 댓글 삭제"
          description="이 배너 댓글을 정말로 삭제하시겠습니까?"
          confirmText="삭제하기"
          onConfirm={this.onConfirmRemove}
          onCancel={this.onCancelRemove}
          open={removeComment.visible}
        />
      </Fragment>
    );
  }
}

export default connect(
  (state: State) => ({
    logged: !!state.user.user,
    bannerId: state.banners.banner && state.banners.banner.id,
    comments: state.banners.comments,
    subCommentsMap: state.banners.subCommentsMap,
    shouldCancel: state.common.ssr && !state.common.router.altered,
    loading: !state.banners.banner || state.pender.pending['banners/READ_COMMENTS'],
    username: state.user.user && state.user.user.username,
    removeComment: state.banners.removeComment,
    commentsCount: state.banners.banner && state.banners.banner.comments_count,
  }),
  () => ({}),
)(withRouter(BannerCommentsContainer));



// WEBPACK FOOTER //
// ./src/containers/banner/BannerCommentsContainer.js